import React, { useEffect } from "react";
import './About.css'


import Aos from "aos";
import "aos/dist/aos.css";

export default function About() {
  useEffect(() => {
    Aos.init({
      duration: 2000,
      useClassNames: true,
      initClassName: false,
      animatedClassName: "animated",
    });
  });
   const handleClick = () => {
     window.open(
       "https://drive.google.com/file/d/1yig6uZ3FMmPmj-M6ZkQWcwPNhPvCUneb/view"
     );
     window.location.href =
       "https://drive.google.com/uc?export=download&id=1yig6uZ3FMmPmj-M6ZkQWcwPNhPvCUneb";
   };
  return (
    <section className="about section" id="about">
      <div className="about-cont container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div
          id="user-detail-intro"
          className="lg:flex-grow md:w-1/2 lg:pr-28 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center"
        >
          <h1 className="head" data-aos="fade-down">
            <span className="purple"> About </span> Me
          </h1>
          <br></br>
          <br></br>
          <br></br>
          <div>
            <div>
              <div
                md={8}
                className="home-about-description"
                data-aos="fade-right"
              >
                <p className="home-about-body" style={{ fontSize: "1.4em" }}>
                  As a skilled MERN Stack Developer, I possess expertise in the
                  latest tech tools and technologies such as React Js, Node Js,
                  Redux, MongoDB, and JavaScript. With a result-oriented and
                  enthusiastic approach, I thrive on overcoming challenges and
                  continuously expanding my technical skills. I am a quick
                  learner and possess a problem-solving mindset, which allows me
                  to adapt to changing project requirements effortlessly.
                  Overall, I am a highly motivated Full Stack Developer who is
                  passionate about creating innovative and efficient solutions
                  for complex problems.
                </p>
              </div>
            </div>
            <div></div>
          </div>
          <br></br>
          <br></br>
          <br></br>

          <div className="flex justify-center mt-14" data-aos="fade-up">
            <a
              id="resume-button-2"
              onClick={handleClick}
              target="_blank"
              className="inline-flex text-white bg-green-500 border-0 py-3 px-6 focus:outline-none hover:bg-green-600 rounded text-lg"
            >
              Resume
            </a>
            <a
              href="/#projects"
              className="ml-4 inline-flex text-gray-400 bg-gray-800 border-0 py-2 px-6 focus:outline-none hover:bg-gray-700 hover:text-white rounded text-lg"
            >
              Projects
            </a>
          </div>
        </div>
        <div
          className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 m-auto"
          data-aos="fade-left"
        >
          <img
            className="home-img image-approunded-full rounded-t-half rounded-b-full m-auto rounded-r-full and rounded-l-full border-8 w-2/4  "
            alt="img"
            src="/profile.png"
          />
        </div>
      </div>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
    </section>
  );
}
